<template>	
	<div class="w-full">
		<vs-row vs-justify="center">
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="12" vs-sm="12" class="text-left">
				<vs-input 
					class="w-1/2" 
					:label="$t('MODULE.MultiDescription')" 
					:placeholder="$t('MODULE.MultiDescription')" 
					v-model="questionsByPage[index].properties.default"/>
			</vs-col>
		</vs-row>
		<h6 class="vs-input--label mb-3 mt-5">{{$t('MODULE.addOptionsTolist')}}</h6>
		<Options :index="index"></Options>
	</div>
</template>
<script type="text/javascript">	
	import Options from '../../componentsToQuestions/Options.vue';
	import { mapState } from 'vuex';

	export default {
		props: ['index'],
		components: { Options },
		
		computed: {
			...mapState('resource',['questionsByPage']),
		}
	}
	
</script>